import { Pipe, PipeTransform } from '@angular/core';
import { indexOf } from 'lodash';

@Pipe({
  name: 'join',
  pure: true,
})
export class JoinPipe implements PipeTransform {
  transform<T>(
    value: string[] | { [index: number]: string },
    separator: string = '\n'
  ): string {
    if (!Array.isArray(value)) {
      value = Object.values(value);
    }
    return (value as string[]).join(separator);
  }
}
